import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../../services/API";

export const postNeighborhoodCommunityChat = createAsyncThunk("postNeighborhoodCommunityChat", async ({ data }, { rejectWithValue }) => {
    try {
        const response = await axiosInstance.post(`/neighbor_news/community/send/`, data);
        const result = response.data;
        return result;
    } catch (error) {
        if (error.response) {
            return rejectWithValue(error.response.data);
        }
        return rejectWithValue(error.message);
    }
});

export const getNeighborhoodCommunityChats = createAsyncThunk("getNeighborhoodCommunityChats", async (_, { rejectWithValue }) => {
    try {
        const response = await axiosInstance.get(`/neighbor_news/community/messages/`);
        const result = response.data;
        return result;
    } catch (error) {
        if (error.response) {
            return rejectWithValue(error.response.data);
        }
        return rejectWithValue(error.message);
    }
});




export const NeighborhoodCommunityChatSlice = createSlice({
    name: "NeighborhoodCommunityChat",
    initialState: {
        neighborhoodCommunityChat: {},
        loading: false,
        error: null,
    },
    extraReducers: (builder) => {

        builder.addCase(postNeighborhoodCommunityChat.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(postNeighborhoodCommunityChat.fulfilled, (state, action) => {
            state.loading = false;
        });
        builder.addCase(postNeighborhoodCommunityChat.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
        builder.addCase(getNeighborhoodCommunityChats.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(getNeighborhoodCommunityChats.fulfilled, (state, action) => {
            state.loading = false;
            state.neighborhoodCommunityChat = action.payload;
        });
        builder.addCase(getNeighborhoodCommunityChats.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });

    },
});

export default NeighborhoodCommunityChatSlice.reducer;